import React, { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import '../App.css';
import LanguageDropdown from '../LanguageDropdown';
import SignInModal from '../SignInModal';
import RegisterModal from '../RegisterModal';
import ForgotPasswordModal from '../ForgotPasswordModal';
import CursorTrail from '../CursorTrail';
import StarManager from '../StarManager';
import logo from '../shapefx.svg'; 


const Layout = () => {
    const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
    const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('');
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname.split('/')[1];
        setActiveLink(path);
    }, [location]);

    const openSignInModal = () => { setIsRegisterModalOpen(false); setIsForgotPasswordModalOpen(false); setIsSignInModalOpen(true); };
    const closeSignInModal = () => setIsSignInModalOpen(false);
    const openRegisterModal = () => { setIsSignInModalOpen(false); setIsForgotPasswordModalOpen(false); setIsRegisterModalOpen(true); };
    const closeRegisterModal = () => setIsRegisterModalOpen(false);
    const openForgotPasswordModal = () => { setIsSignInModalOpen(false); setIsRegisterModalOpen(false); setIsForgotPasswordModalOpen(true); };
    const closeForgotPasswordModal = () => setIsForgotPasswordModalOpen(false);


    const cometHeadRef = useRef(null);
    useEffect(() => {
        const cursorElement = document.createElement('div');
        cursorElement.className = 'comet-head';
        document.body.appendChild(cursorElement);
        cometHeadRef.current = cursorElement;

        const updateMouseVisual = (e) => {
            if (cometHeadRef.current) {
                cometHeadRef.current.style.left = `${e.clientX}px`;
                cometHeadRef.current.style.top = `${e.clientY}px`;
            }
        };
        document.addEventListener('mousemove', updateMouseVisual);

        const makeCursorInteractive = () => { if (cometHeadRef.current) cometHeadRef.current.classList.add('cursor-interactive-hover'); };
        const makeCursorDefault = () => { if (cometHeadRef.current) cometHeadRef.current.classList.remove('cursor-interactive-hover'); };
        const interactiveSelector = '.nav-group-center a, .nav-group-right-link, .dropdown-item, button, .form-link, .modal-close-button, .nav-logo';
        const handleMouseOver = (e) => { if (e.target.closest(interactiveSelector)) { makeCursorInteractive(); } else { makeCursorDefault(); } };
        document.addEventListener('mouseover', handleMouseOver);

        return () => {
            document.removeEventListener('mousemove', updateMouseVisual);
            document.removeEventListener('mouseover', handleMouseOver);
            if (cometHeadRef.current && document.body.contains(cometHeadRef.current)) {
                document.body.removeChild(cometHeadRef.current);
            }
        };
    }, []);

    return (
        <>
            <header>
                <nav className="main-nav">
                    <Link to="/" className="nav-logo">
                        <img src={logo} alt="ShapeFX Logo" />
                    </Link>
                    <ul className="nav-group-center">
                        <li> <Link to="/forum" className={activeLink === 'forum' ? 'active' : ''}> FORUM <i className="fa-solid fa-comments"></i> </Link> </li>
                        <li> <Link to="/discover" className={activeLink === 'discover' ? 'active' : ''}> DISCOVER TALENT </Link> </li>
                        <li> <Link to="/about" className={activeLink === 'about' ? 'active' : ''}> <i className="fa-solid fa-circle-info"></i> ABOUT </Link> </li>
                    </ul>
                    <ul className="nav-group-right">
                        <LanguageDropdown />
                        <li> <a id="signin" href="#signin" onClick={(e) => { e.preventDefault(); openSignInModal(); }} className="nav-group-right-link"> SIGN IN <i className="fa-regular fa-circle-user"></i> </a> </li>
                    </ul>
                </nav>
            </header>
            
            <main className="content-outlet">
                <Outlet />
            </main>

            <CursorTrail />
            <StarManager />

            {isSignInModalOpen && <SignInModal isActuallyOpen={isSignInModalOpen} onClose={closeSignInModal} onSwitchToRegister={openRegisterModal} onSwitchToForgotPassword={openForgotPasswordModal} />}
            {isRegisterModalOpen && <RegisterModal isActuallyOpen={isRegisterModalOpen} onClose={closeRegisterModal} onSwitchToSignIn={openSignInModal} />}
            {isForgotPasswordModalOpen && <ForgotPasswordModal isActuallyOpen={isForgotPasswordModalOpen} onClose={closeForgotPasswordModal} onSwitchToSignIn={openSignInModal} />}
        </>
    );
};

export default Layout;